
































































































































import Vue from 'vue';
import { ToastProgrammatic as Toast } from 'buefy';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'TextInput',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {},
  data() {
    return {
      textFileUpload: false,
      title: '',
      text: '',
      textFile: null as unknown as File,
      authorFirstName: '',
      authorFamilyName: '',
      published: '',
    };
  },
  methods: {
    ...mapActions('text', ['postText']),
    sendText() {
      const {
        title,
        text,
        textFile,
        authorFirstName,
        authorFamilyName,
        published,
      } = this;
      const formData = new FormData();
      formData.append('title', title);
      formData.append('authorFirstName', authorFirstName);
      if (authorFamilyName !== '') formData.append('authorFamilyName', authorFamilyName);
      if (published !== '') formData.append('published', new Date(published).toISOString());
      if (text !== '') formData.append('text', text);
      if (textFile) formData.append('textFile', textFile);

      this.postText(formData)
        .then(() => {
          Toast.open({
            message: `"${title}" uploaded successfully!`,
            type: 'is-success',
          });
          (this.$parent as Vue & { close: () => undefined }).close();
        })
        .catch((error) => {
          Toast.open({
            message: `${error} &mdash; occurred when uploading "${title}"`,
            type: 'is-danger',
          });
        });
    },
    deleteDropFile() {
      this.textFile = null as unknown as File;
    },
  },
});
